"use strict";

module.exports = function (accumulator, order, product) {
  if (!product.design_name) {
    return accumulator;
  }

  var addition = product.design_name.split(' ').reverse().join('');

  if (accumulator.length && addition.length) {
    return accumulator + '-' + addition;
  }

  return addition;
};